import React from "react";
import logger from "../../utils/LoggerFrontend";

import * as SC from "./NewMetricsReport.styled";
import Theme from "../../theme";
import { ThemeProvider } from "styled-components";
import Header from "../../PagesUser/Campaign/DataVisualization/Header/Header";
import PrintInteractionMetrics from "./PrintInteractionMetrics/PrintInteractionMetrics";
import PrintMessage from "./PrintMessage/PrintMessage";
import PrintFooter from "./PrintFooter/PrintFooter";
import { useTranslation } from "react-i18next";
import { PrintFunnel } from "./PrintFunnel/PrintFunnel.jsx";
import { PrintRatings } from "./PrintRatings/PrintRatings.jsx";
import { withRouter } from "react-router-dom";
import withRefluxStore from "../../Stores/withRefluxStore.jsx";
import { Store__System } from "@talentbait/shared-components";
import { useEnrichedDailyData, usePerformanceMetrics } from "../../hooks/use-enriched-data.hook.js";
import { PrintPlatforms } from "./PrintPlatforms/PrintPlatforms.jsx";

// metrics-report/:orgaId/:id
const NewMetricsReport = ({ match, interaction, userProfile }) => {
  const { t } = useTranslation();
  const { id: campaignId } = match.params;

  logger.log("CampaignRead:NewMetricsReport", "render", { campaignId, interaction });

  const { campaignData, metrics } = useEnrichedDailyData(campaignId);
  const chartData = usePerformanceMetrics(campaignId);

  logger.log("CampaignRead:NewMetricsReport", "metrics data", { metrics });

  if (!metrics) {
    return null;
  }

  const {
    platformBreakdown,
    statusBreakdown = {},
    ratingsBreakdown = [],
    averageRating
  } = metrics || {};

  const campaignGoal = campaignData?.campaignGoal;
  const showCreativeTable = campaignData?.showCreativeTable;

  logger.log("CampaignRead:NewMetricsReport", "metrics, goal and creative flag", {
    metrics,
    campaignGoal,
    showCreativeTable,
    statusBreakdown,
    platformBreakdown
  });

  const statuses = Object.values(statusBreakdown)?.[0] || [];
  const platforms = Object.values(platformBreakdown)?.[0] || [];
  const totalCandidates = platforms?.reduce((sum, item) => sum + item?.value || 0, 0);

  const printAllMetrics = () => {
    return (
      <SC.Group direction="column">
        {campaignGoal === "applicants" && (
          <>
            <PrintFunnel statuses={statuses} />
            <SC.Group width={1180}>
              <PrintPlatforms
                platforms={platforms}
                language={userProfile?.language}
                totalAmount={totalCandidates}
              />
              <PrintRatings
                ratings={ratingsBreakdown}
                averageRating={averageRating}
                language={userProfile?.language}
              />
            </SC.Group>
          </>
        )}
        <PrintInteractionMetrics chartData={chartData} minClicks={campaignData?.minClicks} />
      </SC.Group>
    );
  };

  return (
    <ThemeProvider theme={Theme}>
      <SC.GlobalStyle />
      <SC.MainWrapper>
        <SC.Content>
          <Header campaignData={campaignData} isPrint />
          {interaction && <PrintInteractionMetrics />}
          {!interaction && printAllMetrics()}
          <SC.PrintMessageWrapper>
            <SC.PrintMessageTitle className="print-message-wrapper">
              {t("Explanations")}
            </SC.PrintMessageTitle>
            <SC.PrintMessages>
              <PrintMessage title="Great news" content="print.report.greatNews" />
              <PrintMessage title="All good" content="print.report.allGood" />
              <PrintMessage title="To improve" content="print.report.toImprove" />
            </SC.PrintMessages>
          </SC.PrintMessageWrapper>
          <PrintFooter />
        </SC.Content>
      </SC.MainWrapper>
    </ThemeProvider>
  );
};

export default withRouter(withRefluxStore(NewMetricsReport, [Store__System], ["userProfile"]));
